<!-- フローティングリンク -->
<template>
  <div id="com_side_fixed_cnt1_wrap">
    <div id="com_side_fixed_cnt1" :class="{ open: isOpneFloating }">
      <div @click="toggleOpenFloating">
        <div>奨励・表彰制度進捗状況</div>
      </div>
      <div>
        <div>
          <a class="button1" href="#" @click.prevent="handleShosaiLinkClick">
            <span class="text">
              <span class="text__item">実績詳細</span>
              <span class="text__item" aria-hidden="true">実績詳細</span>
            </span>
          </a>
          <div class="now1">
            <img :src="imageClock" alt="" />
            {{ "＜" + hokokuYear + "年" + hokokuMonth + "月末時点＞進捗状況" }}
          </div>
          <div class="now1">■奨励制度</div>
          <dl class="data1">
            <dt>売上増加（累計）</dt>
            <dd>
              <span
                class="roboto"
                :class="{ negative: isNegative(shoreiRuikeiZokagaku) }"
              >
                {{ shoreiRuikeiZokagaku }}
              </span>
              円
            </dd>
          </dl>
          <dl class="data1">
            <dt>奨励金進捗（参考）</dt>
            <dd>
              <span
                class="roboto"
                :class="{ negative: isNegative(shoreiShinchokuJokyo) }"
              >
                {{ shoreiShinchokuJokyo }}
              </span>
              円
            </dd>
          </dl>
          <div class="now1">■表彰制度</div>
          <dl class="data1">
            <dt>売上（累計）</dt>
            <dd>
              <span
                class="roboto"
                :class="{ negative: isNegative(hyoshoRuikeiZokagaku) }"
              >
                {{ hyoshoRuikeiZokagaku }}
              </span>
              円
            </dd>
          </dl>
          <dl class="data1">
            <dt>ユニーク稼働（累計）</dt>
            <dd>
              <span
                class="roboto"
                :class="{ negative: isNegative(hyoshoRuikeiKadoId) }"
              >
                {{ hyoshoRuikeiKadoId }}
              </span>
              ID
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { outputDebugLogs, formatMessage, getTargetDate } from "@/Common";
import { AxiosError } from "axios";
import messages from "@/assets/messages.json";
import { useRouter } from "vue-router";
import ImageClock from "@/assets/common/img/icon-clock1.png";

export default defineComponent({
  name: "FloatingLinkComponent",
  setup() {
    const isOpneFloating = ref(false); // フローティングリンク展開／縮小フラグ
    const agCode = ref("");
    const userId = ref("");
    const hokokuYear = ref("");
    const hokokuMonth = ref("");
    const shoreiRuikeiZokagaku = ref("");
    const shoreiShinchokuJokyo = ref("");
    const hyoshoRuikeiZokagaku = ref("");
    const hyoshoRuikeiKadoId = ref("");
    const daihyoCode = ref("");
    const router = useRouter();
    const imageClock = ref(ImageClock);
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID

    // 初期処理
    onMounted(async () => {
      // ローカルストレージの情報削除
      localStorage.removeItem(AppConstants.INCENTIVE_SYSTEM_KBN_SESSION_NAME);
      localStorage.removeItem(AppConstants.INCENTIVE_AG_CODE_SESSION_NAME);
      localStorage.removeItem(AppConstants.INCENTIVE_DAIHYO_CODE_SESSION_NAME);
      localStorage.removeItem(AppConstants.INCENTIVE_USER_ID_SESSION_NAME);
      localStorage.removeItem(AppConstants.INCENTIVE_TOKEN_SESSION_NAME);

      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
        pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
        pseudoUserId.value = parsedUserInfo.pseudoUserId;
      }

      if (pseudoUserId.value == "") {
        // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
        serchAgCode.value = agCode.value;
        serchUserId.value = userId.value;
      } else {
        outputDebugLogs("疑似ログイン状態");
        serchAgCode.value = pseudoAgCode.value;
        serchUserId.value = pseudoUserId.value;
      }

      try {
        outputDebugLogs("インセンティブフローティングデータ取得");

        // インセンティブフローティングデータ取得APIを実行
        const response = await apiAuthClient.post(
          "/api/Incentive/getIncentiveFloating",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: serchAgCode.value,
            userId: serchUserId.value,
            targetDate: getTargetDate(""),
          }
        );
        hokokuYear.value = response.data.hokokuYear;
        hokokuMonth.value = response.data.hokokuMonth;
        shoreiRuikeiZokagaku.value = response.data.shoreiRuikeiZokagaku;
        shoreiShinchokuJokyo.value = response.data.shoreiShinchokuJokyo;
        hyoshoRuikeiZokagaku.value = response.data.hyoshoRuikeiZokagaku;
        hyoshoRuikeiKadoId.value = response.data.hyoshoRuikeiKadoId;
        daihyoCode.value = response.data.daihyoCode;

        outputDebugLogs("インセンティブフローティングデータ取得成功");
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "フローティングデータの取得"));
      } finally {
        // n/a
      }
    });

    /**
     * フローティングリンクの展開／縮小
     */
    const toggleOpenFloating = () => {
      isOpneFloating.value = !isOpneFloating.value;
    };

    /**
     * 実績詳細リンククリック時
     */
    const handleShosaiLinkClick = async () => {
      try {
        // 連携ログイン情報登録APIを実行
        const response = await apiAuthClient.post("/api/Auth/RegRenkeiLogin", {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: daihyoCode.value,
          userId: serchUserId.value,
        });

        // ローカルストレージの情報設定
        localStorage.setItem(
          AppConstants.INCENTIVE_SYSTEM_KBN_SESSION_NAME,
          process.env.VUE_APP_SYSTEM_KBN
        );
        localStorage.setItem(
          AppConstants.INCENTIVE_AG_CODE_SESSION_NAME,
          serchAgCode.value
        );
        localStorage.setItem(
          AppConstants.INCENTIVE_DAIHYO_CODE_SESSION_NAME,
          daihyoCode.value
        );
        localStorage.setItem(
          AppConstants.INCENTIVE_USER_ID_SESSION_NAME,
          serchUserId.value
        );
        localStorage.setItem(
          AppConstants.INCENTIVE_TOKEN_SESSION_NAME,
          response.data.token
        );

        // インセンティブ画面を新しいタブで開く
        const routeData = router.resolve({
          name: "Incentive",
        });
        window.open(routeData.href, "_blank");
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        if (axiosError.response) {
          switch (axiosError.response.status) {
            default:
              alert(formatMessage(messages.ERR_SYS003, "トークンの取得"));
          }
        } else {
          alert(formatMessage(messages.ERR_SYS999));
        }
      } finally {
        // n/a
      }
    };

    /**
     * 数値がマイナス値か判定します。
     * @param target
     */
    const isNegative = (target: string | null): boolean => {
      if (target) {
        // 負の数、負のカンマ区切り数、小数、負のパーセンテージを判定
        const regex = /^-\d{1,3}(,\d{3})*(\.\d+)?%?$/;
        return regex.test(target.trim());
      }
      return false;
    };

    return {
      isOpneFloating,
      toggleOpenFloating,
      hokokuYear,
      hokokuMonth,
      shoreiRuikeiZokagaku,
      shoreiShinchokuJokyo,
      hyoshoRuikeiZokagaku,
      hyoshoRuikeiKadoId,
      isNegative,
      handleShosaiLinkClick,
      imageClock,
    };
  },
});
</script>

<style scoped>
#com_side_fixed_cnt1_wrap {
  display: block;
  position: fixed;
}
#com_side_fixed_cnt1 .button1 .text {
  font-size: 18pt;
  height: 1.7em;
}
.negative {
  color: red;
}
</style>
